<template>
  <div class="ksm-page-wrapper">
    <split-layout
      :cols="showTextInfo?3:2"
      @clickCollapse="clickCollapse"
      @dragStop="dragStop"
      :sidebar_left_width="'width:20% '"
      :sidebar_right_width="'width:600px;'"
    >
      <div v-show="showTextInfo" slot="sidebar-1" class="ksm-flex-1" style="position:relative;">
        <SidebarView :list="sidebarLeftList" :hiddenToolbar="true"></SidebarView>
      </div>
      <!-- split-layout main -->
      <div slot="main-content" class="ksm-texte__modus-main">
        <template v-if="geoData">
          <MapView :geoData="geoData" @inited="mapInited" :option="mapOption"></MapView>
        </template>
      </div>
      <!-- split-layout main end -->
      <!-- spit-layout sidebar -->
      <div slot="sidebar-2" class="ksm-flex-1" style="position:relative">
        <SidebarView :list="sidebarRightList"></SidebarView>
      </div>
    </split-layout>
  </div>
</template>

<script>
import MapView from "comps/MapView.vue";
import SplitLayout from "comps/SplitLayout.vue";
import { setTimeout } from "timers";
import SidebarView from "./orte/Sidebar.OrteUndWege";

export default {
  name: "orteundwege",
  data() {
    return {
      map: null,
      geoData: null,
      mapOption: {
        showControls: true,
        showPiechart: true,
        splitLayoutResize: null
      }
    };
  },
  components: {
    MapView,
    SplitLayout,
    SidebarView
  },
  created: function() {
    this.$store.dispatch("orteundwege/fetchGeoData",this).then(res => {
      this.geoData = res;
    });
  },
  computed: {
    sidebarRightList() {
      return this.$store.getters["orteundwege/sidebarRightList"];
    },
    sidebarLeftList() {
      return this.$store.getters["orteundwege/sidebarLeftList"];
    },
    showTextInfo() {
      if (!this.sidebarLeftList) {
        return;
      }
      const isExpand = this.sidebarRightList.find(it => it.isExpand);
      return ["holland", "merzabende", "merzgebiete"].indexOf(isExpand.id) > -1;
    }
  },
  methods: {
    clickCollapse() {
      // this.mapUpdate();
    },
    dragStop() {
      this.mapUpdate();
      this.mapOption.splitLayoutResize = new Date().getTime();
      // console.log("dragStop");
    },
    mapUpdate() {
      const map = this.map;
      if (map) {
        setTimeout(function() {
          map.updateSize();
        }, 300);
      }
    },
    mapInited(map) {
      this.map = map;
    }
  }
};
</script>

<style lang="scss">
.ksm-page-wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-content-font;
  @extend .ksm-flex;
  position: relative;
  justify-content: center;
  background-color: $lightGrey;
}
</style>


// WEBPACK FOOTER //
// OrteUndWege.vue?1585069a